import React, { useEffect, useRef, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";

function SoloarPotential({ view }) {
  const dispatch = useDispatch()
  const { isTheme } = useSelector((state) => state.currentStage)
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const [ulbs, setUlbs] = useState([]);
  const [selectedUlb, setSelectedUlb] = useState("");
  const [ulbCode, setUlbCode] = useState("");
  const [wards, setWards] = useState([]);
  const [selectedWard, setSelectedWard] = useState("");
  const [wardCode, setWardCode] = useState("");
  const authData = useSelector(state => state.authToken.authData);


  useEffect(() => {
    const loadDistricts = async () => {
      const url =
        "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
          const formattedDistricts = [{
            districtName: authData?.DistrictName,
            districtCode: authData?.DistrictCode,
          }];
          setDistricts(formattedDistricts);
          setDistrictCode(authData?.DistrictCode);
          setSelectedDistrict(authData?.DistrictName);
          await loadUlbs(authData?.DistrictCode)
        } else {
          if (data.features) {
            const formattedDistricts = data.features.map((f) => ({
              districtName: f.properties.districtname,
              districtCode: f.properties.dist_cd,
            }));
            setDistricts(formattedDistricts);
          }
        }
      } catch (error) {
        console.log("Error fetching districts:", error);
      }
    };

    loadDistricts();
  }, []);

  const handleDistrictChange = async (event) => {
    const selectedValue = event.target.value;
    const selectedDistrictObj = districts.find(d => d.districtCode === selectedValue);
    dispatch(setIsDist(selectedValue))
    if (selectedDistrictObj) {
      setSelectedDistrict(selectedDistrictObj.districtName);
      setDistrictCode(selectedDistrictObj.districtCode);

      setUlbs([]);
      setUlbCode("");
      setSelectedUlb("");

      await loadUlbs(selectedDistrictObj.districtCode);
    } else {
      setSelectedDistrict("");
      setDistrictCode("");
      setUlbs([]);
      setUlbCode("");
      setSelectedUlb("");
    }
  };


  const loadUlbs = async (dist_cd) => {
    // Try the primary service first
    const primaryUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;

    try {
      const response = await fetch(primaryUrl);
      const data = await response.json();
      if (authData?.UserType === "User") {
        const formattedUlbs = [{
          ulbName: authData?.UlbName,
          ulbCode: authData?.Ulb_Code,
        }];
        setUlbs(formattedUlbs);
        setUlbCode(authData?.Ulb_Code);
        setSelectedUlb(authData?.UlbName);
        await loadWards(authData?.Ulb_Code);
      } else if (data.features) {
        const formattedUlbs = data.features.map(f => ({
          ulbName: f.properties.name,
          ulbCode: f.properties.ulb_cd,
        }));
        setUlbs(formattedUlbs);
      }

      // If primary service didn't return data, try the fallback service
      const fallbackUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;

      const fallbackResponse = await fetch(fallbackUrl);
      const fallbackData = await fallbackResponse.json();

      if (fallbackData.features && fallbackData.features.length > 0) {
        const formattedUlbs = fallbackData.features.map(f => ({
          ulbName: f.properties.name,
          ulbCode: f.properties.ulb_cd,
        }));
        setUlbs(formattedUlbs);
      } else {
        setUlbs([]);
      }

    } catch (error) {
      console.error("Error fetching ULBs:", error);
      try {
        // If primary service failed, try the fallback service
        const fallbackUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;

        const fallbackResponse = await fetch(fallbackUrl);
        const fallbackData = await fallbackResponse.json();

        if (fallbackData.features && fallbackData.features.length > 0) {
          const formattedUlbs = fallbackData.features.map(f => ({
            ulbName: f.properties.name,
            ulbCode: f.properties.ulb_cd,
          }));
          setUlbs(formattedUlbs);
        } else {
          setUlbs([]);
        }
      } catch (fallbackError) {
        console.error("Error fetching ULBs from fallback service:", fallbackError);
        setUlbs([]);
      }
    }
  };


  const handleUlbChange = async (event) => {
    const selectedValue = event.target.value;
    const selectedUlbObj = ulbs.find(ulb => ulb.ulbCode === selectedValue);
    dispatch(setIsUlb(selectedValue));

    if (selectedUlbObj) {
      setSelectedUlb(selectedUlbObj.ulbName);
      setUlbCode(selectedUlbObj.ulbCode);
      setWards([]);
      setWardCode("");
      setSelectedWard("");
      try {
        await loadWards(selectedUlbObj.ulbCode);

      } catch (error) {
        console.error("Failed to zoom to ULB:", error);
        // Optionally show user feedback
      }
    } else {
      setSelectedUlb("");
      setUlbCode("");
      setWards([]); // 
      setWardCode("");
      setSelectedWard("");
    }
  };



  const loadWards = async (ulb_cd) => {
    console.log("Fetching wards for ULB code:", ulb_cd);

    // Try primary service first
    const primaryUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query";
    const primaryQuery = `where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

    try {
      // Try primary service
      const wardResponse = await fetch(`${primaryUrl}?${primaryQuery}`);
      const wardData = await wardResponse.json();

      if (wardData.features && wardData.features.length > 0) {
        // Check if properties exist
        const validFeatures = wardData.features.filter(f =>
          f.properties && f.properties.wardname && f.properties.wardno
        );

        if (validFeatures.length > 0) {
          const formattedWards = validFeatures.map((f) => ({
            wardName: f.properties.wardname,
            wardCode: f.properties.wardno
          }));

          setWards(formattedWards);
          setWardCode("");
          setSelectedWard("");
          return; // Exit if we got valid data
        }
      }

      // If primary service didn't work, try fallback service
      console.log("Primary ward service didn't return valid data, trying fallback...");
      const fallbackUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/7/query";
      const fallbackQuery = `where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

      const fallbackResponse = await fetch(`${fallbackUrl}?${fallbackQuery}`);
      const fallbackData = await fallbackResponse.json();

      if (fallbackData.features && fallbackData.features.length > 0) {
        const validFeatures = fallbackData.features.filter(f =>
          f.properties && (f.properties.wardname || f.properties.wardno)
        );

        const formattedWards = validFeatures.map((f) => ({
          wardName: f.properties.wardname || `Ward ${f.properties.wardno}`, // Fallback if wardname is missing
          wardCode: f.properties.wardno || f.properties.wardname // Fallback if wardno is missing
        }));

        setWards(formattedWards);
        setWardCode("");
        setSelectedWard("");
      } else {
        console.log("No ward data found in either service");
        setWards([]);
      }
    } catch (error) {
      console.log("Error fetching wards:", error);
      try {
        // If primary service failed, try fallback service
        const fallbackUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer/7/query";
        const fallbackQuery = `where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

        const fallbackResponse = await fetch(`${fallbackUrl}?${fallbackQuery}`);
        const fallbackData = await fallbackResponse.json();

        if (fallbackData.features && fallbackData.features.length > 0) {
          const validFeatures = fallbackData.features.filter(f =>
            f.properties && (f.properties.wardname || f.properties.wardno)
          );

          const formattedWards = validFeatures.map((f) => ({
            wardName: f.properties.wardname || `Ward ${f.properties.wardno}`,
            wardCode: f.properties.wardno || f.properties.wardname
          }));

          setWards(formattedWards);
          setWardCode("");
          setSelectedWard("");
        } else {
          console.log("No ward data found in fallback service after error");
          setWards([]);
        }
      } catch (fallbackError) {
        console.log("Error fetching wards from fallback service:", fallbackError);
        setWards([]);
      }
    }
  };

  const handleWardChange = async (event) => {
    const selectedValue = event.target.value;
    const selectedWardObj = wards.find(ward => ward.wardCode === selectedValue);
    dispatch(setIsWard(selectedValue))
    if (selectedWardObj) {
      setSelectedWard(selectedWardObj.wardName);
      setWardCode(selectedWardObj.wardCode);
    } else {
      setSelectedWard(""); // 
      setWardCode("");
    }
  };


  const handleRefresh = () => {
    // First reset all state
    setUlbs([]);
    setSelectedDistrict("");
    setDistrictCode("");
    setUlbCode('');
    setSelectedUlb('');
    setWardCode('');
    setWards([]);
    setWardCode("");
    setSelectedWard("");
    dispatch(setIsDist(""));
    dispatch(setIsUlb(""));
    dispatch(setIsWard(""));

    // Then perform view operations
    if (view) {
      try {
        // Remove all graphics
        view.graphics.removeAll();

        // Go to initial view
        view.goTo({
          target: [78.746567, 23.83403], // Using 'target' instead of 'center'
          zoom: 7
        }).catch(error => {
          console.error("Error during goTo:", error);
        });
      } catch (error) {
        console.error("Error during refresh:", error);
      }
    } else {
      console.warn("View is not available");
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
      borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
      "&:hover": {
        borderColor: "#ccc",
      },
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#d1ede9"
        : state.isFocused
          ? "#d1ede9"
          : "#FFFFFF",
      color: "#000",
      fontSize: "12px",
      padding: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#000",
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
  };


  return (

    <div>
      <div className='tooltitlediv linear-gradian-bg'>
        <h6 className="tools-title text-white m-0">View ULB Map</h6>
      </div>
      <div className="mt-2">
        <label className="lebel-card-text">Select District</label>
        <Select
          options={districts.map((district) => ({
            value: district.districtCode,
            label: district.districtName,
          })).sort((a, b) => a.label.localeCompare(b.label))}
          value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
          onChange={(selectedOption) => {
            if (!selectedOption) {
              handleRefresh(); // Call function when clearing
            } else {
              handleDistrictChange({ target: { value: selectedOption?.value || "" } });
            }
          }}

          placeholder="Select District"
          isClearable={true}
          styles={customStyles}
          // className="mt-2"
          isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
        />
      </div>
      {/* ULB */}
      <div className="mt-2">
        <label className="lebel-card-text">Select ULB</label>
        <Select
          options={ulbs.map((ulbs) => ({
            value: ulbs.ulbCode,
            label: ulbs.ulbName,
          })).sort((a, b) => a.label.localeCompare(b.label))}
          value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
          onChange={(selectedOption) =>
            handleUlbChange({ target: { value: selectedOption?.value || "" } })
          }
          placeholder={"Select ULB"}
          isClearable={true}
          styles={customStyles}
          isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode}
        // className="mt-2"
        />
      </div>
      <div className="mt-2">
        <label className="lebel-card-text">Select Ward</label>
        <Select
          options={wards.map((wards) => {
            console.log("wardCode:", wards.wardCode, "wardName:", wards.wardName);
            return {
              value: wards.wardCode,
              label: wards.wardName,
            };
          })}

          value={wardCode ? { value: wardCode, label: selectedWard } : null}
          onChange={(selectedOption) =>
            handleWardChange({ target: { value: selectedOption?.value || "" } })
          }
          placeholder="Select ward"
          isClearable={true}
          styles={customStyles}
          isDisabled={!ulbCode}
        // className="mt-2"
        />
      </div>

      <button
        className="btn-refresh2"
        onClick={handleRefresh}
        style={{ marginTop: "10px" }}
      >
        {isTheme === 'light' ?
          <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
          :
          <img src="img/refresh.svg" alt="refresh" />
        }
        Refresh
      </button>
    </div>
  )
}

export default SoloarPotential
